import { Box, Button, Card, CardBody, CardFooter, CardHeader, Center, Flex, HStack, Heading, Link, Spacer, Text, VStack, Wrap, WrapItem, chakra } from "@chakra-ui/react";
import { NavBar } from "../components/NavBar";
import { CkbIcon, EthIcon, JoyIDIcon, MetaMaskIcon, ZkSyncIcon } from "../icons/Icons";
import { Footer } from "../components/Footer";
import { useEffect, useRef, useState } from "react";
import React from "react";
import MagicCircle from "../icons/multichain-circle.svg"

export const ConstructCirclePage = () => {
    return (
        <VStack  spacing={4}>
            <NavBar />
            <Center m={10}>
                <chakra.img src={MagicCircle} width="1000px" height="1000px" />
            </Center>
            <Footer />
        </VStack>
    );
}